<gipi-abstract-form id="dialogCreditClientCancel"
                    name="dialogCreditClientCancel">
    <gipi-toolbar mat-dialog-title
                  id="toolbarDialogCreditClientCancel">
        Cancelar crédito do cliente
    </gipi-toolbar>

    <div mat-dialog-content
         fxLayout="column"
         fxLayoutGap="16px"
         style="overflow: hidden !important;">
        <div fxLayout="row"
             fxLayoutAlign="start"
             fxLayoutGap="16px"
             fxLayout.lt-sm="column">
            <gipi-input-select-paged label="Categoria"
                                     id="creditClientCancelPostingCategory"
                                     name="creditClientCancelPostingCategory"
                                     [required]="true"
                                     [disabled]="loading"
                                     [(model)]="postingCategory"
                                     [nextBatchFn]="postingCategoryFindByValueFn"
                                     [propertyFn]="postingCategoryFn"
                                     fxFlex>
            </gipi-input-select-paged>
        </div>
        <div fxLayout="row"
             fxLayoutAlign="start"
             fxLayoutGap="16px"
             fxLayout.lt-sm="column">
            <itss-textarea label="Observação"
                           [rows]="5"
                           [required]="true"
                           [disabled]="loading"
                           [(ngModel)]="description"
                           fxFlex
                           fxFlex.lt-md="100">
            </itss-textarea>
        </div>
    </div>
    <div mat-dialog-actions
         fxLayout="row"
         fxLayoutAlign="end center"
         fxLayoutGap="16px">
        <gipi-button label="Confirmar"
                     gipi-primary
                     id="btnSave"
                     [disabled]="loading"
                     [loading]="loading"
                     (click)="confirm()"
                     fxFlex.xl="30"
                     fxFlex.gt-xs>
        </gipi-button>
        <gipi-button label="Voltar"
                     gipi-secondary
                     id="btnReturn"
                     (click)="close(false)"
                     fxFlex.xl="30"
                     fxFlex.gt-xs>
        </gipi-button>
    </div>
</gipi-abstract-form>